import { trigger, animate, style, group, animateChild, query, stagger, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition('* <=> *', [
    query(':enter, :leave', style({ position: 'absolute', height: '100%', width: '100%' }), { optional: true }),
    query(':enter .circle, :enter .link', style({ opacity: 0 }), { optional: true }),
    group([
      query(':leave', [
        style({ opacity: 1 }),
        animate(200, style({ opacity: 0 }))
      ], { optional: true }),
      query(':enter', [
        style({ opacity: 0 }),
        animate(200, style({ opacity: 1 }))
      ], { optional: true }),
    ]),
    group([
      query(':enter .circle', [
        style({ opacity: 0 }),
        animate(200, style({ opacity: 1 }))
      ], { optional: true }),
      query(':enter .link', stagger(30, [
        style({ transform: 'translateY(100px)' }),
        animate('300ms ease-in-out', style({ opacity: 1, transform: 'translateX(0px)' }))
      ]), { optional: true })
    ])
  ])
])


// import { trigger, animate, style, group, animateChild, query, stagger, transition } from '@angular/animations';
//
// export const routerTransition = trigger('routerTransition', [
//   transition('* <=> *', [
//     query(':enter, :leave', style({ position: 'absolute', height: '100%', width: '100%' }), { optional: true }),
//     group([  // block executes in parallel
//       query(':leave', [
//         style({ opacity: 1 }),
//         animate(500, style({ opacity: 0 }))
//       ], { optional: true }),
//       query(':enter', [
//         style({ opacity: 0 }),
//         animate(500, style({ opacity: 1 }))
//       ], { optional: true }),
//     ])
//   ])
// ])
